import { ApiResponseObject } from "../../types";

import storage from "../../utils/storage";
import { UserRoles } from "./auth.constants";
import { authRepo } from "./auth.repo";
import {
  IFindCompanyByPibResponse,
  IGetUserRolesResponse,
  IResetPasswordPayload,
} from "./auth.types";

class AuthService {
  loginSSO = () => {
    return authRepo.loginSSO();
  };

  logoutSSO = () => {
    return authRepo.logoutSSO();
  };

  loginSSOPro = () => {
    return authRepo.loginSSOPro();
  };

  logoutSSOPro = () => {
    return authRepo.logoutSSOPro();
  };

  setRole = (role: UserRoles[]) => {
    storage.setData("role", role);
  };

  getRole = (): UserRoles[] => {
    return storage.getData("role");
  };

  setShowAddDrustvo = (showAddDrustvo: boolean) => {
    storage.setData("showAddDrustvo", showAddDrustvo);
  };

  getShowAddDrustvo = (): boolean => {
    return storage.getData("showAddDrustvo") || false;
  };

  activateDrustvo = (
    pib: string,
    tipId: number
  ): Promise<IFindCompanyByPibResponse> => {
    return authRepo.activateDrustvo(pib, tipId);
  };

  resetPassword = (payload: IResetPasswordPayload) => {
    return authRepo.resetPassword(payload);
  };

  getUserRoles = (): Promise<IGetUserRolesResponse> => {
    return authRepo.getUserRoles();
  };

  getUserCompanies = () => {
    return authRepo.getUserCompanies();
  };

  selectUserCompany = (
    drustvoId: number
  ): Promise<ApiResponseObject<{ drustvoId: number }>> => {
    return authRepo.selectUserCompany(drustvoId);
  };
}

export const authService = new AuthService();
